import React, { useEffect, useMemo, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

const actionTitles = {
  schedule: "Schedule Deletion",
  fail: "Mark Request As Failed",
};

export default function UserDeletionActionModal({
  show,
  onClose,
  actionType,
  onSubmit,
  loading,
}) {
  const [deletionScheduledAt, setDeletionScheduledAt] = useState("");
  const [failureReason, setFailureReason] = useState("");

  useEffect(() => {
    if (!show) {
      setDeletionScheduledAt("");
      setFailureReason("");
    }
  }, [show]);

  const title = useMemo(() => actionTitles[actionType] || "Update Request", [actionType]);

  const handleSubmit = async () => {
    if (actionType === "schedule") {
      if (!deletionScheduledAt) return;
      await onSubmit({
        deletionScheduledAt: new Date(deletionScheduledAt).toISOString(),
      });
      return;
    }

    if (actionType === "fail") {
      if (!failureReason.trim()) return;
      await onSubmit({ failureReason: failureReason.trim() });
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "14px" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {actionType === "schedule" && (
          <Form.Group controlId="deletionScheduledAt">
            <Form.Label className="small text-muted fw-semibold">
              Deletion Scheduled At
            </Form.Label>
            <Form.Control
              type="datetime-local"
              value={deletionScheduledAt}
              onChange={(e) => setDeletionScheduledAt(e.target.value)}
            />
          </Form.Group>
        )}

        {actionType === "fail" && (
          <Form.Group controlId="failureReason">
            <Form.Label className="small text-muted fw-semibold">
              Failure Reason
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={failureReason}
              onChange={(e) => setFailureReason(e.target.value)}
              placeholder="Enter reason"
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="success" size="sm" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Saving...
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
